import { logWrapper } from '../../utils';
import swal from 'sweetalert2';

export default {
  signCertificataController: [
    'runtimeConstant',
    '$scope',
    '$rootScope',
    '$timeout',
    '$filter',
    '$location',
    'authService',
    'signCertificataService',
    '$window',
    'docs',
    '$uibModal',
    '$anchorScroll',
    function (
      runtimeConstant,
      $scope,
      $rootScope,
      $timeout,
      $filter,
      $location,
      authService,
      service,
      $window,
      docs,
      uibModal,
      $anchorScroll
    ) {
      'use strict';

      function IsPhoneValid(phone) {
        var regex = /^\+55\d{2}\d{4,5}\d{4}$/;
        phone = phone
          .replace('-', '')
          .replace(/\s/g, '')
          .replace('(', '')
          .replace(')', '');
        return regex.test(phone);
      }

      function IsMailValid(email) {
        var re =
          /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
        if (!re.test(email)) {
          return false;
        } else {
          return true;
        }
      }

      function IsNameValid(name) {
        const char = /\w|\s_/;
        const numberAndUnder = /\d|\_/;
        if (!char.test(name)) {
          return false;
        }
        if (numberAndUnder.test(name)) {
          return false;
        } else {
          return true;
        }
      }

      function sendSingerSettings() {
        if ($scope.certificataTokenApi) {
          var credendials = {
            tokenApi: $scope.certificataTokenApi,
          };

          service.sendCertificataCredendials(credendials).then(
            function () {
              $timeout($scope.$close(), 200);
              authService.loadUser().then(function () {
                swal.fire({
                  title: $filter('translate')('CREDENTIAL SAVED SUCCESSFULLY'),
                  text: $filter('translate')('CREDENTIAL SAVED SUCCESSFULLY'),
                  showConfirmButton: true,
                  allowEscapeKey: false,
                  allowOutsideClick: false,
                  icon: 'success',
                });
                $location.path('/');
                $location.search('');
                $scope.credendialsCertificata = true;
              });
            },
            function () {
              $scope.messageTitle = $filter('translate')(
                'CERTIFICATA CREDENTIAL'
              );
              $scope.messageDescription = $filter('translate')(
                'FAILED TO SAVE CREDENTIALS'
              );
              $scope.messageCancel = 'OK';

              $scope.errorModal = uibModal.open({
                scope: $scope,
                animationEnabled: true,
                backdrop: 'static',
                templateUrl: '/views/modal/errorModal/errorModal.html',
                controller: 'signCertificataController',
                backdrop: 'static',
                keyboard: true,
                size: 'm',
              });
            }
          );
        } else {
          $scope.isError = true;
          $scope.errorMessage = $filter('translate')(
            'FILL IN THE API TOKEN DATA'
          );
        }
      }

      function cancelButton() {
        $scope.errorModal.close();
      }

      function closeModal(option = false) {
        if (option) {
          if ($scope.tokenApi !== null) {
          }
        }
        $scope.$close();
        if ($scope.loadDocuments !== undefined) {
          $scope.loadDocuments();
          $window.location.reload();
        } else {
          $location.path('/');
          $location.search('');
        }
      }

      function closeModalSigners() {
        $scope.$close();
      }

      function deleteInputs(div) {
        const divFather = document.querySelector('#form-certificata');
        divFather.parentNode.removeChild(`#${div}`);
      }

      function addInputs() {
        let lastElement = $scope.rows[$scope.rows.length - 1];
        $anchorScroll(`${lastElement}`);
        $scope.rows.push($scope.rows.length);
        $scope.typeContactRow[$scope.rows.length - 1] = '1';
      }

      function deleteInputs(id) {
        if (id === 0) {
          return null;
        }
        const div = document.getElementById(id);
        div.innerHTML = '';
      }

      function getLabel(row) {
        return $scope.typeContactRow[row] === '1'
          ? 'TEXT EMAIL'
          : 'TEXT WHATSAPP';
      }

      function changeTypeContact(row) {
        if ($scope.typeContactRow[row] === '1') {
          $scope.selectedContact[row] = '';
        } else {
          $scope.selectedContact[row] = '+55';
        }

        $scope.RequestSignature.splice(row, 1);
      }

      function sendEnvelope() {
        var newArrayRequestSignature = [];

        for (var i = 0; i < $scope.signers.length; i++) {
          var s = $scope.signers[i];

          var isEmail = s.type === 'email';

          var isValidContact = isEmail
            ? IsMailValid(s.contact)
            : IsPhoneValid(s.contact);

          var isValidName = IsNameValid(s.name);

          if (!isValidContact || !isValidName) {
            var typeLabel = isEmail ? 'E-mail' : 'Whatsapp';

            $scope.messageTitle = !isValidContact
              ? typeLabel + ' Inválido!'
              : 'Nome Inválido';

            $scope.messageDescription = !isValidContact
              ? `Você digitou um ${typeLabel} inválido: ` + s.contact
              : 'Você digitou um nome inválido: ' + s.name;

            $scope.messageCancel = 'OK';

            $scope.errorModal = uibModal.open({
              scope: $scope,
              animationEnabled: true,
              backdrop: 'static',
              templateUrl: '/views/modal/errorModal/errorModal.html',
              controller: 'signCertificataController',
              keyboard: true,
              size: 'm',
              resolve: {
                docs: () => docs,
              },
            });

            return;
          }

          newArrayRequestSignature.push({
            PartName: s.name,
            Email: isEmail ? s.contact.trim().toLowerCase() : '',
            Phone: !isEmail
              ? s.contact
                  .replace('-', '')
                  .replace(/\s/g, '')
                  .replace('(', '')
                  .replace(')', '')
              : '',
            Order: $scope.isOrder ? i + 1 : 1
          });
        }

        var envelope = {
          title: docs[0].title,
          IdsRevision: [docs[0].id],
          RequestSignature: newArrayRequestSignature,
          IsOrder: $scope.isOrder
        };

        if (newArrayRequestSignature.length > 0) {
          service
            .postEnvelope(envelope)
            .then(function () {
              swal.fire({
                title: 'Documento enviado para os signatários',
                showConfirmButton: true,
                allowEscapeKey: false,
                allowOutsideClick: false,
                icon: 'success',
              });

              $rootScope.signCertificataModal.close();
            })
            .catch(function (data) {
              $scope.messageTitle = $filter('translate')(
                'ERROR SIGNING DOCUMENT'
              );
              $scope.messageDescription = data.text;
              $scope.messageCancel = 'OK';

              $scope.errorModal = uibModal.open({
                scope: $scope,
                animationEnabled: true,
                backdrop: 'static',
                templateUrl: '/views/modal/errorModal/errorModal.html',
                controller: 'signCertificataController',
                keyboard: true,
                resolve: {
                  docs: () => docs,
                },
              });
            });

          if ($scope.resultModal === true) {
            $scope.getSignersCertificata();
          }
        } else {
          $scope.messageTitle = $filter('translate')('ERROR SIGNING DOCUMENT');
          $scope.messageDescription = $filter('translate')(
            'CERTIFICATA DIFFERENT MAIL'
          );
          $scope.messageCancel = 'OK';

          $scope.errorModal = uibModal.open({
            scope: $scope,
            animationEnabled: true,
            backdrop: 'static',
            templateUrl: '/views/modal/errorModal/errorModal.html',
            controller: 'signCertificataController',
            keyboard: true,
            size: 'm',
          });
        }
      }

      function getSignersCertificata() {
        $scope.resultModal = true;
        $scope.titleDoc = docs[0].title;
        var idRevision = docs[0].id;
        var revisionNumber = docs[0].revisionNumber;

        $scope.signatures = [];

        service
          .getSignersCertificata(idRevision, revisionNumber)
          .then((signers) => {
            signers.forEach((signer) => {
              $scope.Signfilter = {
                Email: signer.Email,
                Phone: signer.Phone,
                PartName: signer.PartName,
                Status: $scope.DescriptionStatus(signer.Status),
                Id: signer.Id,
                Link: null,
              };
              $scope.signatures.push($scope.Signfilter);
            });
          });
      }

      function isCertificataToken() {
        if (authService.user.certificataTokenApi === undefined) {
          return false;
        } else {
          return true;
        }
      }

      function DescriptionStatus(status) {
        switch (status) {
          case 0:
            return 'Pendente';
          case 1:
            return 'Assinado';
          case 2:
            return 'Rejeitado';
        }
      }

      function GetLinkSing(item) {
        if ($scope.isCertificataToken()) {
          service.getLinkSignersCertificata(item.Id).then((link) => {
            $scope.signatures.forEach((x) => {
              if (x.Id === item.Id) {
                x.Link = link.Link;
              }
            });
          });
        }
      }

      function getSuggestions(term, typeChannel) {
          var minLength = 3;

          if (typeChannel === 'whatsapp') {
              minLength = 7;
          }

          if (!term || term.length < minLength) {
              return [];
          }

          $scope.loadingAutocomplete[typeChannel] = true;

          return service
              .getSuggestionsSignersCertificata(term, typeChannel)
              .then(function (data) {
                  return data;
              })
              .catch(function () {
                  return [];
              })
              .finally(function () {
                  $scope.loadingAutocomplete[typeChannel] = false;
              });
      }

      function addSigner() {
        $scope.signers.push({
          name: '',
          type: 'email',
          contact: ''
        });

        initSortable();
      }

      function createEmptySigner() {
        return {
          name: '',
          type: 'email',
          contact: ''
        };
      }

      function removeSigner(index) {
        $scope.signers.splice(index, 1);
      }

      function initSortable() {
        $timeout(function () {
          var el = document.getElementById('sortableList');
          if (!el) return;

          if ($scope.sortableInstance) return;

          $scope.sortableInstance = new Sortable(el, {
            animation: 150,
            handle: '.drag-handle',
            disabled: !$scope.isOrder,

            onEnd: function (evt) {
              var movedItem = $scope.signers.splice(evt.oldIndex, 1)[0];
              $scope.signers.splice(evt.newIndex, 0, movedItem);
              $scope.$apply();
            }
          });
        }, 0);
      }

      function onTypeChange(signer) {
        signer.contact = signer.type === 'whatsapp' ? '+55' : '';
      }

      function run() {
        try {
          $scope.certificataTokenApi = '';
          $scope.credendialsCertificata = false;
          $scope.signerName = '';
          $scope.signerEmail = '';
          $scope.typeContact = '1';
          $scope.rows = [0];
          $scope.typeContactRow = {
            0: '1',
          };
          $scope.RequestSignature = [];
          $scope.resultModal = false;

          $scope.suggestionsEmail = [];
          $scope.suggestionsPhone = [];
          $scope.selectedContact = {};
          $scope.loadingAutocomplete = {};

          $scope.isOrder = false;
          $scope.signers = [createEmptySigner()];
          $scope.sortableInstance = null;

          $scope.$watch('isOrder', function (val) {
            if ($scope.sortableInstance) {
              $scope.sortableInstance.option('disabled', !val);
            }
          });

          $scope.sortableOptions = {
            handle: '.drag-handle'
          };

          $scope.sendSingerSettings = logWrapper(
            sendSingerSettings,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.cancelButton = logWrapper(
            cancelButton,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.closeModal = logWrapper(
            closeModal,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.closeModalSigners = logWrapper(
            closeModalSigners,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.deleteInputs = logWrapper(
            deleteInputs,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.addInputs = logWrapper(
            addInputs,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.deleteInputs = logWrapper(
            deleteInputs,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getLabel = logWrapper(
            getLabel,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.changeTypeContact = logWrapper(
            changeTypeContact,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.sendEnvelope = logWrapper(
            sendEnvelope,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getSignersCertificata = logWrapper(
            getSignersCertificata,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.isCertificataToken = logWrapper(
            isCertificataToken,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.DescriptionStatus = logWrapper(
            DescriptionStatus,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.GetLinkSing = logWrapper(
            GetLinkSing,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getSuggestions = logWrapper(
            getSuggestions,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.addSigner = logWrapper(
            addSigner,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.createEmptySigner = logWrapper(
            createEmptySigner,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.removeSigner = logWrapper(
            removeSigner,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.initSortable = logWrapper(
            initSortable,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.onTypeChange = logWrapper(
            onTypeChange,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
